// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__24LKh","head":"ProcedureTableInfo_head__22Cel"};